import axios, { AxiosRequestConfig } from 'axios';

/**
 * 封装新请求对象的GET请求方法
 * @param url 请求地址
 * @param data 请求入参对象
 * @param config 请求配置项
 * @returns 返回请求参数
 */
export const axiosGet = async <R = any, Q = any>(url: string, data?: Q, config?: AxiosRequestConfig<Q>) => {
  return await axios.get<R, R, Q>(url, { params: data, ...config });
};

/**
 * 封装新请求对象的POST请求方法
 * @param url 请求地址
 * @param data 请求入参对象
 * @param config 请求配置项
 * @returns 返回请求参数
 */
export const axiosPost = async <R = any, Q = any>(url: string, data?: Q, config?: AxiosRequestConfig<Q>) => {
  return await axios.post<R, R, Q>(url, data, config);
};

/**
 * 封装新请求对象的PUT请求方法
 * @param url 请求地址
 * @param data 请求入参对象
 * @param config 请求配置项
 * @returns 返回请求参数
 */
export const axiosPut = async <R = any, Q = any>(url: string, data?: Q, config?: AxiosRequestConfig<Q>) => {
  return await axios.put<R, R, Q>(url, data, config);
};
